import { RootState } from "@app/types"
import { Store } from "redux"

interface AppVersions {
    webAppVersion: string
    nativeAppVersion: string
    nativeAppBuildNumber: string
    osName: string
    osVersion: string
}

const selectAppVersions = (store: Store<RootState, any>): AppVersions => {
    const { appEnvConfig } = store.getState()

    const reduxValues = {
        nativeAppVersion: String(appEnvConfig.version || "0"),
        nativeAppBuildNumber: String(appEnvConfig.buildNumber || "0"),
        osName: String(appEnvConfig.os || "unknown"),
        osVersion: String(appEnvConfig.osVersion || "0"),
    }

    const processEnvValues = {
        webAppVersion: String(`${process.env.APP_VERSION}` || "unknown"),
    }

    return { ...reduxValues, ...processEnvValues }
}

export default selectAppVersions
